module.exports = __webpack_public_path__ + "static/media/logo.fe31856e.png";